var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterestRate1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_934_12778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5224 16.4002C49.1861 10.8948 45.4036 5.96867 39.7863 4.43902C32.7339 2.51854 25.4598 6.67879 23.5393 13.7313C22.7063 16.7902 23.0179 19.8905 24.2127 22.578H24.2126L21.8463 27.4385H27.9072C29.35 28.6186 31.0325 29.4885 32.8315 29.9784C38.4584 31.5107 44.2263 29.1718 47.3036 24.5816M41.5391 11.1828L31.215 23.4563M11.613 6.49286L4.1123 15.2497H8.23864V27.5599H14.9872V15.2497H19.1136L11.613 6.49286Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4108 15.8689C33.8108 15.8689 34.9456 14.7444 34.9456 13.3573C34.9456 11.9702 33.8108 10.8457 32.4108 10.8457C31.0109 10.8457 29.876 11.9702 29.876 13.3573C29.876 14.7444 31.0109 15.8689 32.4108 15.8689Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1579 23.8376C41.5578 23.8376 42.6927 22.7131 42.6927 21.326C42.6927 19.9389 41.5578 18.8145 40.1579 18.8145C38.7579 18.8145 37.623 19.9389 37.623 21.326C37.623 22.7131 38.7579 23.8376 40.1579 23.8376Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5301 46.0287H2.94564C2.13431 46.0287 1.47656 45.371 1.47656 44.5596V42.9183C1.47656 42.107 2.13431 41.4492 2.94564 41.4492H12.5302C13.3416 41.4492 13.9993 42.107 13.9993 42.9183V44.5596C13.9992 45.3711 13.3415 46.0287 12.5301 46.0287Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9902 46.0287H15.4681C14.6568 46.0287 13.999 45.371 13.999 44.5596V42.9183C13.999 42.107 14.6568 41.4492 15.4681 41.4492H24.9902C25.8015 41.4492 26.4592 42.107 26.4592 42.9183V44.5596C26.4592 45.3711 25.8015 46.0287 24.9902 46.0287Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4504 46.03H27.9283C27.117 46.03 26.4592 45.3722 26.4592 44.5609V42.9196C26.4592 42.1082 27.117 41.4505 27.9283 41.4505H37.4504C38.2617 41.4505 38.9194 42.1082 38.9194 42.9196V44.5609C38.9193 45.3723 38.2617 46.03 37.4504 46.03ZM12.5301 41.4506H2.94564C2.13431 41.4506 1.47656 40.7928 1.47656 39.9815V38.3402C1.47656 37.5288 2.13431 36.8711 2.94564 36.8711H12.5302C13.3416 36.8711 13.9993 37.5288 13.9993 38.3402V39.9815C13.9992 40.7929 13.3415 41.4506 12.5301 41.4506Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9902 41.4506H15.4681C14.6568 41.4506 13.999 40.7928 13.999 39.9815V38.3402C13.999 37.5288 14.6568 36.8711 15.4681 36.8711H24.9902C25.8015 36.8711 26.4592 37.5288 26.4592 38.3402V39.9815C26.4592 40.7929 25.8015 41.4506 24.9902 41.4506Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9902 36.8705H15.4681C14.6568 36.8705 13.999 36.2128 13.999 35.4014V33.7601C13.999 32.9488 14.6568 32.291 15.4681 32.291H24.9902C25.8015 32.291 26.4592 32.9488 26.4592 33.7601V35.4014C26.4592 36.2129 25.8015 36.8705 24.9902 36.8705Z",
    stroke: "#212529",
    strokeOpacity: 0.8,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_934_12778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestRate1);
export default __webpack_public_path__ + "static/media/interest-rate 1.b3dc98fa876b6a2e259b5402d493defd.svg";
export { ForwardRef as ReactComponent };